module.exports = __webpack_public_path__ + "img/irish-cancer-society.26cc0ca5.png";